import React from 'react';

import { Theme, withStyles, WithStyles } from "@material-ui/core/styles";

import { AppState, IPageState }
  from '../../appredux';

import { connect } from 'react-redux';

import { Typography } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Flag from 'react-flagkit';

export type FlagData1 = {
  flag: string;
  prefix: string;
  name: string;
  nameEn: string;
} 

const FlagData =
  [{ flag: 'pl', prefix: '48', name: "Polska", nameEn: "Poland" },
  { flag: 'at', prefix: '43', name: "Austria", nameEn: "Austria" },
  { flag: 'au', prefix: '61', name: "Australia", nameEn: "Australia" },
  { flag: 'be', prefix: '32', name: "Belgia", nameEn: "Belgium" },
  { flag: 'bg', prefix: '359', name: "Bułgaria", nameEn: "Bulgaria" },
  { flag: 'by', prefix: '375', name: "Białoruś", nameEn: "Belarus" },
  { flag: 'ca', prefix: '1', name: "Kanada", nameEn: "Canada" },
  { flag: 'ch', prefix: '41', name: "Szwajcaria", nameEn: "Switzerland" },
  { flag: 'cz', prefix: '420', name: "Czechy", nameEn: "Czech Republic" },
  { flag: 'de', prefix: '49', name: "Niemcy", nameEn: "Germany" },
  { flag: 'dk', prefix: '45', name: "Dania", nameEn: "Denmark" },
  { flag: 'es', prefix: '34', name: "Hiszpania", nameEn: "Spain" },
  { flag: 'ee', prefix: '372', name: "Estonia", nameEn: "Estonia" },
  { flag: 'fi', prefix: '358', name: "Finlandia", nameEn: "Finland" },
  { flag: 'fr', prefix: '33', name: "Francja", nameEn: "France" },
  { flag: 'gb', prefix: '44', name: "Wielka Brytania", nameEn: "Great Britain" },
  { flag: 'gr', prefix: '30', name: "Grecja", nameEn: "Greece" },
  { flag: 'hr', prefix: '385', name: "Chorwacja", nameEn: "Croatia" },
  { flag: 'hu', prefix: '36', name: "Węgry", nameEn: "Hungary" },
  { flag: 'ie', prefix: '353', name: "Irlandia", nameEn: "Ireland" },
  { flag: 'it', prefix: '39', name: "Włochy", nameEn: "Italy" },
  { flag: 'jp', prefix: '81', name: "Japonia", nameEn: "Japan" },
  { flag: 'lt', prefix: '370', name: "Litwa", nameEn: "Lithuania" },
  { flag: 'lv', prefix: '371', name: "Łotwa", nameEn: "Latvia" },
  { flag: 'nl', prefix: '31', name: "Holandia", nameEn: "Netherlands" },
  { flag: 'no', prefix: '47', name: "Norwegia", nameEn: "Norway" },
  { flag: 'nz', prefix: '64', name: "Nowa Zelandia", nameEn: "New Zeland" },
  { flag: 'pt', prefix: '351', name: "Portugalia", nameEn: "Portugal" },
  { flag: 'ru', prefix: '7', name: "Rosja", nameEn: "Russia" },
  { flag: 'se', prefix: '46', name: "Szwecja", nameEn: "Sweeden" },
  { flag: 'si', prefix: '386', name: "Słowenia", nameEn: "Slovenia" },
  { flag: 'sk', prefix: '421', name: "Słowacja", nameEn: "Slovakia" },
  { flag: 'ua', prefix: '380', name: "Ukraina", nameEn: "Ukraine" },
  { flag: 'us', prefix: '11', name: "USA", nameEn: "USA" }]

export const getPrefix = (lang: string): string => {
  const prefix: FlagData1 | undefined = FlagData.find((e) => (e.flag === 'gb' ? 'en' : e.flag) === lang);


  if (prefix)
    return prefix.prefix;
  else
    return '';
}

type PickerProps = {
  //roomCategory : string,
  page: IPageState,
  anchorEl: Element | ((element: Element) => Element) | null,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
  openMenu: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  closeMenu: () => void,
  selectItem: (setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void, flag: string, prefix: string) => void,
  disabled?: boolean
  //close : () => void,
}

type PickerState = {
  //selected : boolean,
  //  rooms: webVacant[],
}

class PrefixPicker extends React.Component<PickerProps & WithStyles<typeof styles>, PickerState>  {

  // constructor(props : any) {
  //   super(props, {});

  //   this.state = {

  //   }
  // }

  //PM 2021-08-26
  //aktualizacja z zaktualizowana wersja react-flagkit
  render = () => {
    const { classes } = this.props;
    const open = Boolean(this.props.anchorEl);

    //console.log(getLabel("pl"))
    //console.log(getLabel("PL"))
    //let tab = FlagData.sort((a, b) => a.nameEn < b.nameEn ? -1 : 1)
    let tab = FlagData.sort((a, b) => a.name < b.name ? -1 : 1)

    let prefiksy = this.props.page.prefiksy
    if(prefiksy){
      tab = prefiksy.map(x => {

        return {
          flag: x.domena !== "uk" ? x.domena : "gb",
          prefix: x.prefiks.substring(1),
          name: x.opis,
          nameEn: ""
        }
      })

      tab = tab.sort((a, b) => a.name < b.name ? -1 : 1)
    }

    

    //let flag = this.props.page.lang == "en" ? "gb" : this.props.page.lang

    return (

      <InputAdornment position="start" style={{ padding: "0" }}  >
        {/* <AccountCircle /> */}
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={this.props.openMenu}
          disabled={this.props.disabled}
          style={{ padding: "0" }}
        >
          {/* <DetailsRoundedIcon/> */}
          <MoreHorizIcon style={{ fontSize: "1rem" }} />
          <Flag country={this.props.page.langPhone.flag === "en" ? "GB" : this.props.page.langPhone.flag.toUpperCase()} className={classes.img} />
        </IconButton>

        <Menu
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "center", horizontal: "center" }}
          transformOrigin={{ vertical: "center", horizontal: "center" }}
          anchorEl={this.props.anchorEl}
          id="long-menu"
          //anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={this.props.closeMenu}
          PaperProps={{
            style: {
              //maxHeight: 10 * 4.5,
              width: '36ch',
              //width: '20ch',
            },
          }}

          MenuListProps={{
            style: {
              //maxHeight: 10 * 4.5,
              //width: '30ch',
              color: "#3a87ad",
              paddingTop: "0",
              //paddingBottom: "0"
            },
          }}
        >
          {tab.map((c, index) => (
            <MenuItem
              key={index}
              //disabled={this.props.page.langPhone.flag == c.flag && value.includes(c.prefix)}
              selected={this.props.page.langPhone.flag === c.flag}
              onClick={(event: React.MouseEvent<HTMLLIElement, MouseEvent>) => this.props.selectItem(this.props.setFieldValue, c.flag, c.prefix + "")}
            >
              <Flag country={c.flag.toUpperCase()} />
              <Typography variant="h6" component="h2" className={classes.text} style={{ width: "170px", paddingLeft: "15px" }}>
                {c.name.length > 20 ? c.name.substring(0,17) + "..." : c.name}
              </Typography>
              {/* <Typography variant="h6" component="h2"  className={classes.text} style={{width: "20px", paddingLeft: "15px"}} >
              {c.flag} 
            </Typography> */}
              <Typography variant="h6" component="h2" className={classes.text}>
                {c.prefix}
              </Typography>
            </MenuItem>
          ))}

        </Menu>

      </InputAdornment>

    )
  }
}

const styles = (theme: Theme) => ({
  text: {
    //color: theme.palette.text.secondary,
    color: "#3a87ad",
    paddingLeft: "10px",
    fontSize: "1em"
  },
  flag: {
    paddingLeft: "10px"
  },
  textField: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  body: {
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight
  },
  primary: {
    color: theme.palette.primary.main
  },
  back: {
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
    background: "linear-gradient(to bottom, #e49a4d, #c9823c)",
    border: "1px solid #c9823c",
    padding: "6px 8px 5px",
    lineHeight: "13px",
    fontSize: "11px",
    marginTop: "24px"
  },
  paper: {
    overflow: "visible"
  },
  headline: {
    fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600
  },
  img: {
    paddingLeft: '10px'
  }
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default
  connect(mapStateToProps)(withStyles(styles)(PrefixPicker));

export { FlagData };